import { Component, OnInit } from '@angular/core';
import { InstanceService } from '../../../services';

@Component({
    standalone: false,
    selector: 'app-update-instance-statistic-button',
    templateUrl: './update-instance-statistic-button.component.html',
    styleUrls: ['./update-instance-statistic-button.component.scss']
})
export class UpdateInstanceStatisticButtonComponent implements OnInit {
    constructor(private readonly instanceService: InstanceService) {}

    ngOnInit(): void {}

    updateInstanceStatistic() {
        return this.instanceService.getUpdatedSelectedInstanceStatistic(true);
    }
}
